/* eslint-disable unicorn/filename-case */
import { IGraduateDisciplineShow } from 'interfaces/graduate_disciplines';
import { Space, Tag } from 'antd';
import { useMemo } from 'react';
import { useSelect } from '@refinedev/antd';

const MIN_SEARCH_LENGTH = 2;

export const useDisciplineSelect = () => {
  const { selectProps, queryResult } = useSelect<IGraduateDisciplineShow>({
    resource: 'graduate_disciplines',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => {
      if (value.length < MIN_SEARCH_LENGTH) {
        return [];
      }
      return [
        {
          field: 'filter[q]',
          operator: 'eq',
          value
        }
      ];
    },

    pagination: {
      mode: 'server'
    }
  });

  const options = useMemo(
    () =>
      (queryResult.data?.data || []).map(discipline => ({
        value: discipline.id,
        label: (
          <Space size={6}>
            <span>{discipline.name}</span>
            <Tag style={{ margin: 0 }}>{discipline.code}</Tag>
            {discipline.external_reference && (
              <span style={{ color: 'rgba(0,0,0,0.45)' }}>
                {discipline.external_reference}
              </span>
            )}
          </Space>
        )
      })),
    [queryResult.data?.data]
  );

  return { selectProps, options, queryResult };
};
